import { Store, createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { StoreState } from './types/state';
import { composeWithDevTools } from 'redux-devtools-extension';
import { analyticsMiddleware } from './middlewares/analytics';
import { enableMapSet } from 'immer';
let store: Store<StoreState>;

const initialState = {};

let middleWares = [thunk, analyticsMiddleware];

let composeEnhancer = compose(
  composeWithDevTools(applyMiddleware(...middleWares))
);

if (process.env.NODE_ENV === 'production')
  composeEnhancer = compose(applyMiddleware(...middleWares));

enableMapSet();
store = createStore(rootReducer, initialState, composeEnhancer);
export default store;
